const initialState = {
    companyUniqueIdentifier: "TEST"
};

function companyReducer(state = initialState, action){
    
    return state;
}

export default companyReducer;